import './App.css';
import Inputs from "./inputs";

function App() {
  return (
    <div className="App">
      <Inputs />
    </div>
  );
}

export default App;
